// extracted by mini-css-extract-plugin
module.exports = {"type-tabs":"jVVLt","typeTabs":"jVVLt","type-tab":"Xr3n8","typeTab":"Xr3n8","not-active":"D1Uwz","notActive":"D1Uwz"};